var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgArrowback(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M3.5 7.5H13.5C13.6326 7.5 13.7598 7.55268 13.8536 7.64645C13.9473 7.74021 14 7.86739 14 8C14 8.13261 13.9473 8.25979 13.8536 8.35355C13.7598 8.44732 13.6326 8.5 13.5 8.5H3.5C3.36739 8.5 3.24021 8.44732 3.14645 8.35355C3.05268 8.25979 3 8.13261 3 8C3 7.86739 3.05268 7.74021 3.14645 7.64645C3.24021 7.55268 3.36739 7.5 3.5 7.5Z",
    fill: "black"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M3.70789 8L7.85489 12.146C7.94878 12.2399 8.00152 12.3672 8.00152 12.5C8.00152 12.6328 7.94878 12.7601 7.85489 12.854C7.76101 12.9479 7.63367 13.0006 7.50089 13.0006C7.36812 13.0006 7.24078 12.9479 7.14689 12.854L2.64689 8.354C2.60033 8.30755 2.56339 8.25238 2.53818 8.19163C2.51297 8.13089 2.5 8.06577 2.5 8C2.5 7.93423 2.51297 7.86911 2.53818 7.80836C2.56339 7.74762 2.60033 7.69244 2.64689 7.646L7.14689 3.146C7.24078 3.05211 7.36812 2.99937 7.50089 2.99937C7.63367 2.99937 7.76101 3.05211 7.85489 3.146C7.94878 3.23988 8.00152 3.36722 8.00152 3.5C8.00152 3.63277 7.94878 3.76011 7.85489 3.854L3.70789 8Z",
    fill: "black"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgArrowback);
export default __webpack_public_path__ + "static/media/arrowback.6312b9cf924a93777cb4885b7327fd84.svg";
export { ForwardRef as ReactComponent };